import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';
import wordmark from '@/assets/wntd-wordmark.svg';

/**
 * Loading skeleton for Saves page that uses the animated W logo
 * Shows branded loading animation with skeleton cards underneath
 */
export function SavesLoadingSkeleton() {
  return (
    <div className="space-y-4">
      {/* Branded loading header */}
      <div className="flex flex-col items-center justify-center py-8">
        <motion.div
          className="relative"
          animate={{
            scale: [1, 1.1, 1],
            opacity: [0.7, 1, 0.7],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        >
          <img src={wordmark} alt="" className="h-5 w-auto" />
        </motion.div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="mt-3 text-sm text-muted-foreground"
        >
          Loading your saves...
        </motion.p>
      </div>

      {/* Skeleton grid */}
      <div className="grid grid-cols-2 gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
          >
            <div className="rounded-xl overflow-hidden bg-card border border-border">
              <Skeleton className="aspect-[3/4] w-full" />
              <div className="p-3 space-y-2">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-3 w-1/2" />
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
